export default __webpack_public_path__ + "static/media/img-slider-asaph-5.da16332d.png";